import DeviceService from 'Faster/service/DeviceService';
import EventService from 'Faster/service/EventService';
import SessionService from 'Faster/service/SessionService';
import DeviceStorage from 'Faster/storage/DeviceStorage';
import SessionStorage from 'Faster/storage/SessionStorage';
import FasterConfiguration from 'Faster/FasterConfiguration';
import FasterHttpClient from 'Faster/network/FasterHttpClient';
import { LocalStorage, StorageStrategy, StandardHttpCookiesStorage } from 'Faster/storage/StorageStrategy';
import WindowNameStorage from 'Faster/storage/WindowNameStorage';
import StorageEngine from 'Faster/storage/StorageEngine';
import ServerDateService from './service/ServerDateService';
import GeoService from './service/GeoService';

class AnalyticsService {
  private static UPDATE_STORAGE_INTERVAL = 60000;

  public readonly deviceService: DeviceService;
  public readonly sessionService: SessionService;
  public readonly eventService: EventService;
  public readonly serverDateService: ServerDateService;
  public readonly geoService: GeoService;

  private storages: StorageStrategy[] = [new LocalStorage(), new StandardHttpCookiesStorage(), new WindowNameStorage()];

  public constructor(configuration: FasterConfiguration, externalDeviceId?: string, externalSessionId?: string) {
    const httpClient = new FasterHttpClient(configuration);
    const storageEngine = new StorageEngine(this.storages);
    const deviceStore = new DeviceStorage(storageEngine, externalDeviceId);
    const sessionStore = new SessionStorage(storageEngine, externalSessionId);

    const sessionService = new SessionService(httpClient, deviceStore, sessionStore, configuration, externalSessionId);
    this.sessionService = sessionService;
    this.deviceService = new DeviceService(deviceStore, sessionService, configuration, httpClient, externalDeviceId);
    this.eventService = new EventService(httpClient, deviceStore, sessionStore, configuration);
    this.serverDateService = new ServerDateService(httpClient);
    this.geoService = new GeoService(httpClient);
    storageEngine.startUpdateInterval(AnalyticsService.UPDATE_STORAGE_INTERVAL);
  }

  public init(trackInstall: boolean): void {
    this.deviceService.init(trackInstall);

    this.sessionService.refresh(this.deviceService.get());
  }
}

export default AnalyticsService;
